import {
  StyledLink,
  StyledMenu,
  StyledNav,
} from '@swarm/ui/presentational/Menu'
import SvgIcon from '@swarm/ui/swarm/SvgIcon'
import { useTranslation } from 'react-i18next'

import { ROUTES } from 'src/routes'

interface MenuProps {
  open: boolean
}

const Menu = ({ open }: MenuProps) => {
  const { t } = useTranslation('navigation')

  return (
    <StyledMenu open={open}>
      <StyledNav>
        <StyledLink to={ROUTES.STAKING}>
          <SvgIcon
            height="32px"
            style={{ marginRight: '24px', marginLeft: '4px' }}
            name="staking-chart"
            color="white"
          />
          {t('menu.staking')}
        </StyledLink>
      </StyledNav>
    </StyledMenu>
  )
}

export default Menu
